import merge from 'lodash.merge';
import { removeUndefinedAttributes } from 'util/remove-undefined-attributes';
import { sanitiseAuthConfig } from './auth-config/auth-config.config';
import { getAuthStrategiesRuntime } from './auth-strategies/auth-strategies';
import { sanitiseAuthStrategiesConfig } from './auth-strategies/auth-strategies.config';
import { getServicesConfig } from './services-config';
import { getSessionIdConfig } from './session-id/session-id.config';
import { getUserConfig } from './user-config/user-config.config';
import { getBrandConfig } from './brand/brand.config';
import { IOSGIConfig } from '../interfaces';
import { getTokenCacheStrategy } from './auth-token-cache-strategy';

export const sanitiseRuntimeConfig = (config: IOSGIConfig['runtimeConfig']): IOSGIConfig['runtimeConfig'] => {
	return merge(
		sanitiseAuthConfig(config.authConfig),
		getAuthStrategiesRuntime(
			sanitiseAuthStrategiesConfig(config.authStrategiesConfig, config.authConfig),
		),
		getTokenCacheStrategy(),
		getServicesConfig({
			...config.servicesConfig,
			environment: config.authConfig?.environment
		}),
		removeUndefinedAttributes(getSessionIdConfig(config.sessionId)),
		removeUndefinedAttributes(getUserConfig(config.userConfig)),
		removeUndefinedAttributes(getBrandConfig(config.brand)));
};
